import React from "react";
import {
  VStack,
  FormControl,
  FormLabel,
  Input,
  Button,
  HStack,
  IconButton,
  useClipboard,
  useColorModeValue,
} from "@chakra-ui/react";
import { CopyIcon } from "@chakra-ui/icons";

interface SharedFormProps {
  fields: Array<{ label: string; name: string; type?: string; value?: any }>;
  initialData?: any;
  onSubmit: (data: any) => void;
  onCancel: () => void;
}

export const SharedForm: React.FC<SharedFormProps> = ({
  fields,
  initialData = {},
  onSubmit,
  onCancel,
}) => {
  const [formData, setFormData] = React.useState<any>(initialData || {});

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(formData);
  };

  // Clipboard for website field
  const websiteValue = formData.website || "";
  const { onCopy } = useClipboard(websiteValue);

  // Theme-aware colors
  const inputBg = useColorModeValue("white", "#23272F");
  const inputBorder = useColorModeValue("#e5e7eb", "#444");
  const labelColor = useColorModeValue("gray.700", "gray.200");

  return (
    <form onSubmit={handleSubmit}>
      <VStack spacing={5} align="stretch" w="100%" py="10px">
        {fields.map((field) =>
          field.name === "website" ? (
            <FormControl key={field.name} mb={1}>
              <FormLabel fontWeight="bold" color={labelColor} mb={2}>
                وبسایت*
              </FormLabel>
              <HStack spacing={2}>
                <Input
                  name={field.name}
                  type="url"
                  placeholder="http://"
                  value={formData[field.name] || ""}
                  onChange={handleChange}
                  borderRadius="lg"
                  bg={inputBg}
                  borderColor={inputBorder}
                  boxShadow="sm"
                  fontSize="md"
                  py={3}
                />
                <IconButton
                  aria-label="کپی"
                  icon={<CopyIcon />}
                  onClick={() => {
                    onCopy();
                  }}
                  colorScheme="gray"
                  variant="outline"
                  size="sm"
                />
              </HStack>
            </FormControl>
          ) : (
            <FormControl key={field.name} mb={1}>
              <FormLabel fontWeight="bold" color={labelColor} mb={2}>
                {field.label}
              </FormLabel>
              <Input
                name={field.name}
                type={field.type || "text"}
                placeholder={`مقدار ${field.label} را وارد کنید`}
                value={formData[field.name] || ""}
                onChange={handleChange}
                borderRadius="lg"
                bg={inputBg}
                borderColor={inputBorder}
                boxShadow="sm"
                fontSize="md"
                py={3}
              />
            </FormControl>
          ),
        )}
        <Button type="submit" size="lg" w="100%" mt={2} py={3}>
          ارسال
        </Button>
      </VStack>
    </form>
  );
};
